module.exports = __webpack_public_path__ + "img/yellow-circle-table-2.3536deb8.png";